<template>
    <div class="commodityList">
        <div class="top" @click="tiaozhuang()">
            <img :src="'/api/file/preview/' + data.cover" alt="" v-if="data.cover" />
            <img src="../../assets/pro-default-img@2x.png" alt="" v-else />

            <div>
                <div class="intro">
                    <div style="display:flex">
                        {{ data.name }}
                        <div v-if="data.newProduct" class="new">new</div>
                    </div>
                    <div>所属商家：{{ data.storeName }}</div>
                </div>
                <div class="details">
                    <div>
                        <div>
                            <span class="details-title">CAS号：</span>
                            <span class="details-value">{{ data.casNum }}</span>
                        </div>
                        <div>
                            <span class="details-title">分子式：</span>
                            <span class="details-value">{{ data.molecularFormula }}</span>
                        </div>
                        <div>
                            <span class="details-title">英文名：</span>
                            <span class="details-value">{{ data.englishName }}</span>
                        </div>
                    </div>
                    <div>
                        <div>
                            <span class="details-title">MDL号：</span>
                            <span class="details-value">{{ data.mdlNum }}</span>
                        </div>

                        <div>
                            <span class="details-title">分子量：</span>
                            <span class="details-value">{{ data.molecularWeight }}</span>
                        </div>

                        <div>
                            <span class="details-title">中文别名：</span>
                            <span class="details-value">{{ data.alias }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="tabe-title">
                <div style="width:112px">货号</div>
                <div style="width:112px">品牌</div>
                <div style="width:113px">包装</div>
                <div style="width:172px">规格</div>
                <div style="width:142px">级别</div>
                <div style="width:82px">交期</div>
                <div style="width:86px">价格</div>
                <div style="width:134px">VIP价格</div>
                <div style="width:95px">库存</div>
                <div style="width:100px">操作</div>
                <div style="width:50px" @click="showTabe()" :class="[show_tabe ? 'close' : 'open', 'switch']">
                    {{ show_tabe ? '收起' : '展开' }}
                    <img src="../../assets/arrow  down@2x.png" alt="" />
                </div>
            </div>
            <template v-if="show_tabe">
                <div class="tabe-item" v-for="item in skuList" :key="item.uuid" v-show="isShow(item)">
                    <div style="width:112px">{{ item.skuSn }}</div>
                    <div style="width:112px">{{ item.brandName }}</div>
                    <div style="width:113px">{{ item.goodsPackage }}</div>
                    <div style="width:172px">{{ item.f_157 }}</div>
                    <div style="width:142px">{{ item.packaging }}</div>
                    <div style="width:82px">{{ disposeDeliveryTime(item.stock) }}</div>
                    <div style="width:86px">¥{{ item.price / 100 }}</div>
                    <div style="width:134px;color:#F24145">{{ getVip(item) }}</div>
                    <div style="width:95px">{{ item.stock }}</div>
                    <div style="width:150px;display:flex">
                        <div class="button button-view" @click="tiaozhuang()">查看详情</div>
                        <div class="button button-add" @click="_addCartPostFun(item)">加入购物车</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data', 'screening'],
    data() {
        return {
            show_tabe: false,
            skuList: [],
            AllList: []
        };
    },
    methods: {
        // 判断是否展示
        isShow(item) {
            let { packaging, deliveryTimeStatus, priceMax, priceMin, storeIdArray, goodsPackage, packagingNew } = this.screening;
            if (packaging && packaging.length != 0) {
                let temp = true;
                packaging.forEach(el => {
                    if (el == item.f_157) {
                        temp = false;
                    }
                });
                if (temp) {
                    return false;
                }
            }
            if (deliveryTimeStatus && deliveryTimeStatus.length) {
                let temp = true;
                if (deliveryTimeStatus == '现货' && item.stock > 0) {
                    temp = false;
                } else if (deliveryTimeStatus == '期货' && !(item.stock > 0)) {
                    temp = false;
                }
                if (temp) {
                    return false;
                }
            }
            if (priceMax != '' && priceMin != '') {
                let temp = true;
                if (priceMax >= item.price / 100 && priceMin <= item.price / 100) {
                    temp = false;
                }

                if (temp) {
                    return false;
                }
            }

            if (goodsPackage && goodsPackage.length) {
                let temp = true;
                goodsPackage.forEach(el => {
                    if (el == item.goodsPackage) {
                        temp = false;
                    }
                });
                if (temp) {
                    return false;
                }
            }

            if (packagingNew && packagingNew.length) {
                let temp = true;
                packagingNew.forEach(el => {
                    if (el == item.packageNewId) {
                        temp = false;
                    }
                });
                if (temp) {
                    return false;
                }
            }
            return true;
        },
        // 发送请求加入购物车，并刷新购物车数量
        _addCartPostFun({ uuid }) {
            const token = localStorage.getItem('uuid');
            if (token) {
                this.api
                    .add_cart({
                        productSkuId: uuid,
                        quantity: 1
                    })
                    .then(res => {
                        if (res.ok) {
                            this.$message.success('操作成功');
                            // 刷新购物车
                            this.$store.commit('updateCartCount');
                            // window.location.reload(true)
                        } else {
                            this.$message.error(res.message);
                        }
                    });
            } else {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                });
            }
        },
        getVip(item) {
            if (item.currentUserVipPrice) {
                if (item.currentUserVipPrice.vipId) {
                    return '¥' + item.currentUserVipPrice.price / 100;
                }
            }
            return '-';
        },
        disposeDeliveryTime(val) {
            if (val > 0) {
                return '现货';
            } else {
                return '期货';
            }
        },
        showTabe() {
            // console.log(this.data);
            let deliveryTimeStatus = '';
            let search = '';
            // console.log(this.screening, 'fffffffffffffffffffffffffffff');
            if (this.screening.deliveryTimeStatus[0]) {
                deliveryTimeStatus = this.screening.deliveryTimeStatus[0];
            }
            if (this.screening.typeAccuracy == 'skuSn') {
                search = this.screening.search;
            }
            if (this.AllList.length == 0) {
                this.api
                    .get_product_sku({
                        productId: this.data.uuid,
                        page: 0,
                        size: 100,
                        storeId: this.data.storeId
                    })
                    .then(res => {
                        let list = [];
                        this.AllList = res.data.content;
                        // if (deliveryTimeStatus || search) {
                        //     if (deliveryTimeStatus == '现货') {
                        //         this.AllList.forEach(item => {
                        //             if (item.stock > 0) {
                        //                 list.push(item);
                        //             }
                        //         });
                        //     } else if (deliveryTimeStatus == '期货') {
                        //         this.AllList.forEach(item => {
                        //             if (!(item.stock > 0)) {
                        //                 list.push(item);
                        //             }
                        //         });
                        //     }
                        //     if (search) {
                        //         list = this.AllList.filter(item => {
                        //             return item.skuSn == search;
                        //         });
                        //     }
                        // } else {
                        list = this.AllList;
                        // }
                        this.skuList = list;
                    });
            } else {
                let list = [];
                // if (deliveryTimeStatus || search) {
                //     if (deliveryTimeStatus == '现货') {
                //         this.AllList.forEach(item => {
                //             if (item.stock > 0) {
                //                 list.push(item);
                //             }
                //         });
                //     } else if (deliveryTimeStatus == '期货') {
                //         this.AllList.forEach(item => {
                //             if (!(item.stock > 0)) {
                //                 list.push(item);
                //             }
                //         });
                //     }
                //     if (search) {
                //         list = this.AllList.filter(item => {
                //             return item.skuSn == search;
                //         });
                //     }
                // } else {
                list = this.AllList;
                // }
                this.skuList = list;
            }
            this.show_tabe = !this.show_tabe;
        },
        tiaozhuang() {
            const token = localStorage.getItem('uuid');
            if (token) {
                const { href } = this.$router.resolve(`/goods_details?uuid=${this.data.uuid}&storeId=${this.data.storeId}`);
                window.open(href, '_blank');
            } else {
                this.$confirm({
                    title: '请先登录',
                    onOk: () => this.$router.push('/login')
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.commodityList {
    margin-bottom: 30px;

    .top {
        display: flex;
        margin-bottom: 10px;

        img {
            width: 100px;
            height: 124px;
        }

        > div {
            padding: 20px 0 10px 20px;
        }

        .intro {
            display: flex;
            margin-bottom: 20px;
            color: #333;
            font-weight: 600;

            > div {
                width: 314px;
            }

            .new {
                height: 18px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 17px;
                background: #f24145;
                border-radius: 100px 100px 100px 0px;
                padding: 0 6px;
                margin-left: 10px;
            }
        }

        .details {
            > div {
                display: flex;

                > div {
                    min-width: 314px;

                    .details-title {
                        display: inline-block;
                        width: 70px;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 26px;
                    }

                    .details-value {
                        display: inline-block;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 26px;
                    }
                }
            }
        }
    }

    .tabe-title {
        padding: 0 20px;
        display: flex;
        line-height: 32px;
        background: #f2f2f2;

        .switch {
            display: flex;
            align-items: center;
            color: #f24145;

            img {
                width: 11px;
                height: 7px;
                margin-left: 8px;
            }
        }

        .close {
            img {
                transform: rotate(180deg);
            }
        }
    }

    .tabe-item {
        padding: 0 20px;
        display: flex;
        line-height: 40px;

        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;

        border-bottom: 1px solid #ede9e9;

        > div {
            white-space: nowrap;
            /* 规定文本是否折行 */
            overflow: hidden;
            /* 规定超出内容宽度的元素隐藏 */
            text-overflow: ellipsis;
        }

        .button {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2b9a34;

            &-add {
                margin-left: 10px;
            }
        }
    }
}

div {
    cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/productList/commodityList.vue